import React from 'react';
import { EMOJI_AUSWAHL } from 'modules/finanzen/features/konstanten';

/** Kleine Emoji-Auswahl fuer eigene Kategorien (kuratierte Liste). */
export default function EmojiPicker({ wert, onChange }) {
  return (
    <div className="flex max-h-28 flex-wrap gap-1 overflow-y-auto">
      {EMOJI_AUSWAHL.map((emoji) => (
        <button
          key={emoji}
          type="button"
          onClick={() => onChange(emoji)}
          className={`h-9 w-9 rounded-lg border text-lg transition-colors ${
            wert === emoji ? 'border-brand-600 bg-brand-600/10' : 'border-line hover:border-brand-400'
          }`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}
